var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.356 512.356",
    height: 512,
    viewBox: "0 0 512.356 512.356",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.178 220.133-65.781 34.488 20.545 163.393h90.473l20.544-163.393z",
    fill: "#fff16b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.959 254.621-65.781-34.488v197.881h45.237z",
    fill: "#ffd321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.136 116.942-111.134-16.277-49.824-100.665-49.824 100.665-111.134 16.277 80.342 78.493-18.861 110.725 99.477-52.154 99.478 52.154-18.861-110.725z",
    fill: "#ffd321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.795 195.435 80.341-78.493-111.134-16.277-49.824-100.665v254.006l99.478 52.154z",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.805 388.014h256.747v124.342h-256.747z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.178 388.014h128.374v124.342h-128.374z",
    fill: "#454040"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m212.852 435.186h86.667v30h-86.667z",
    fill: "#ffd321"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256.178 435.186h43.34v30h-43.34z",
    fill: "#ffaf00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.b2cfebbc3849a26f95c82db7dea89633.svg";
export { ForwardRef as ReactComponent };